// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 19:39:58

export default {
  "id": "obby-massive-attack",
  "slug": "obby-massive-attack",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/aa59f225aa8b49d38e87f18ba4d83f8b-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/aa59f225aa8b49d38e87f18ba4d83f8b/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Obby Massive Attack",
      "description": "Help the Obby blox friends to rescue the hapless citizens of a city. During the adventure, you'll get bonuses that give you superpowers that will allow you to sweep aside everything in your path.\nObby Masive Attack is the ideal game for anyone who loves the running game genre. This time, Obby and friends are the protagonist - the game offers fast gameplay, nice graphics, special effects and good playability.\nCollect coin and buy new power ups, and run forever in this fantastic endless adventure.",
      "instructions": "\nEasy to understand;\nNice and addictive gameplay;\nInfinite runner;\nMany characters to unlock;\nCute Graphics;\nPower ups and shop,\n\nUse the Touch or mouse to Jump",
      "genres": [
        "Adventure",
        "Agility"
      ],
      "tags": [
        "jumping",
        "levels",
        "running"
      ]
    },
    "zh-CN": {
      "title": "奥比：大规模攻击",
      "description": "帮助Obby blox朋友拯救一个不幸城市的市民。在冒险过程中，你将获得赋予你超能力的奖励，让你能清除一切障碍。\nObby Masive Attack是任何喜欢跑步游戏类型的人的理想游戏。这次，Obby和朋友成为主角——游戏提供快速的游戏节奏、精美的图形、特效和良好的可玩性。\n收集金币，购买新的强化技能，在这场精彩的无限冒险中永不停歇。",
      "instructions": "易于理解；\n令人上瘾的游戏玩法；\n无尽跑酷；\n众多角色解锁；\n可爱图形；\n增益道具和商店，\n\n使用触摸或鼠标跳跃",
      "genres": [
        "冒险",
        "敏捷"
      ],
      "tags": [
        "跳跃",
        "关卡",
        "奔跑"
      ]
    },
    "zh-TW": {
      "title": "奧比龐大襲擊",
      "description": "幫助Obby blox朋友拯救那個不幸的城市居民。在這場冒險中，你將獲得獎勵，讓你擁有超能力，能夠清除前方的所有障礙。\nObby Masive Attack是喜愛跑步遊戲類型的理想遊戲。這次，Obby和朋友們是主角——遊戲提供快速的遊戲節奏、優美的圖形、特殊效果和良好的可玩性。\n收集硬幣並購買新能力提升，並在這場奇幻無盡的冒險中永遠奔跑。",
      "instructions": "容易理解；\n遊戲性佳且上癮；\n無限奔跑；\n多種角色可解鎖；\n可愛的圖片；\n強化道具和商店，\n\n使用觸控或滑鼠來跳躍",
      "genres": [
        "冒險",
        "敏捷性"
      ],
      "tags": [
        "跳躍",
        "關卡",
        "奔跑"
      ]
    },
    "zh-HK": {
      "title": "奧比大量攻擊",
      "description": "幫助Obby積木朋友拯救城市裡無辜的市民。在冒險中，你將獲得加值，給予你超級能力，讓你能夠清除前方的所有障礙。\n\nObby Masive Attack是適合所有喜愛跑酷遊戲類型的玩家。這次，Obby和朋友們是主角——遊戲提供快速的遊戲過程、美觀的圖形、特殊效果和良好的可玩性。\n\n收集硬幣並購買新能力加強，在這場奇妙的無限冒險中無限奔跑。",
      "instructions": "易明瞭；\n玩味十足且令人上癮；\n無限奔跑；\n多個角色可解鎖；\n可愛的圖形；\n強力道具及商店，\n\n使用觸控或滑鼠來跳躍",
      "genres": [
        "冒險",
        "靈敏度"
      ],
      "tags": [
        "跳躍",
        "關卡",
        "跑跳"
      ]
    },
    "ja": {
      "title": "オビー・マッスイブ・アタック",
      "description": "オビィブロックスの仲間たちを助け、無力な市民たちを救出する冒険に出かけよう。冒険の間、あなたに特別な力を与えるボーナスを獲得し、道を一切除くことができる。オビーマジックアタックは、ランニングゲームのファンにとって最適なゲームだ。今度は、オビィと仲間たちが主人公となっている。このゲームは速いプレイ、良いグラフィック、特別効果、そして良い操作性を提供している。\n\nコインを集め、新しいパワーアップを購入し、この素晴らしい無限の冒険で永遠に走り続けよう。",
      "instructions": "簡単に理解できます；\n快適で夢中になるゲームプレイ；\n無限ランナー；\n多くのキャラクターを解放できます；\n可愛いグラフィック；\nパワーアップとショップ、\n\nタッチまたはマウスを使ってジャンプしてください。",
      "genres": [
        "アドベンチャー",
        "アギリティー"
      ],
      "tags": [
        "ジャンプ",
        "レベル",
        "ランニング"
      ]
    },
    "ko": {
      "title": "오비 마스시브 어تك트",
      "description": "오비 블록 친구들에게 도움을 주어 도시의 불운한 시민들을 구출하세요. 모험 동안 보너스를 얻어 귀하의 길을 막는 모든 것을 쓸어버릴 수 있는 슈퍼파워를 얻을 수 있습니다.\n오비 마시브 어택은 런닝 게임 장르를 사랑하는 모든 사람들에게 이상적인 게임입니다. 이번에는 오비와 친구들이 주인공입니다 - 게임은 빠른 게임플레이, 좋은 그래픽, 특수 효과, 좋은 플레이어블리티를 제공합니다.\n코인을 모아 새로운 파워업을 구매하고, 이Fantastic Endless Adventure에서 영원히 달릴 수 있습니다.",
      "instructions": "이해하기 쉬움;\n좋고 유혹적인 게임플레이;\n무한 러너;\n해금할 수 있는 많은 캐릭터;\n 귀여운 그래픽;\n 파워업과 상점,\n\n터치나 마우스를 사용하여 점프하세요.",
      "genres": [
        "모험",
        "유연성"
      ],
      "tags": [
        "점프",
        "레벨",
        "달리기"
      ]
    },
    "fr": {
      "title": "Obby Attaque Massif",
      "description": "Aidez les amis Obby blox à sauver les malchanceux citoyens d'une ville. Pendant l'aventure, vous obtiendrez des bonus qui vous donneront des pouvoirs supérieurs pour balayer tout sur votre passage.\nObby Masive Attack est le jeu idéal pour tout le monde qui aime le genre des jeux de course. Cette fois, Obby et ses amis sont les protagonistes - le jeu offre un gameplay rapide, de bonnes graphiques, des effets spéciaux et une bonne jouabilité.\nCollectez des pièces et achetez de nouveaux pouvoirs, et courez éternellement dans cette fantastique aventure sans fin.",
      "instructions": "Facile à comprendre ;\nJeu sympa et accrocheur ;\nJeu de runner infini ;\nNombreux personnages à déverrouiller ;\nGraphismes mignons ;\nBoosts et boutique,\n\nUtilisez le Touch ou la souris pour sauter",
      "genres": [
        "Aventure",
        "Agilité"
      ],
      "tags": [
        "saut",
        "niveaux",
        "course"
      ]
    }
  }
};
